import { AuthActionTypes, All } from '../actions/auth.actions';
import { User } from '@app/shared/models/user';
import { Sso } from '@app/shared/models/sso';
import { UserPrefs } from '@app/shared/models/userPrefs';
import { DashboardData } from '@app/shared/models/dashboardData';

// define State interface
export interface State {
  // is a user authenticated?
  isAuthenticated: boolean;
  // if authenticated, there should be a user object
  user: User | null;
  sso: Sso | null;
  // error message
  errorMessage: string | null;
  prefs:UserPrefs | null;
  dashboardData:DashboardData | null;
  actionType:string | null;
}

// define initial state
export const initialState: State = {
  isAuthenticated: false,
  user: null,
  sso: null,
  errorMessage: null,
  prefs:new UserPrefs(),
  dashboardData: null,
  actionType:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case AuthActionTypes.SSO_SUCCESS:
    case AuthActionTypes.GET_USER_SUCCESS:
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        sso: action.payload.ak,
        user: action.payload.user,
        errorMessage: null,
        prefs: action.payload.prefs,
        actionType:action.type,
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload.error,
        actionType:action.type,
      };
    }

    case AuthActionTypes.LOGOUT_SUCCESS: {
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        actionType:action.type,
      };
    }
    case AuthActionTypes.SET_USER_PREFS_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        prefs: action.payload.prefs,
        actionType:action.type,
      };
    }
    case AuthActionTypes.GET_USER_DASH_SUCCESS: {
      return {
        ...state,
        //successStatus: action.payload.successStatus,
        dashboardData: action.payload.dasboardData,
        actionType:action.type,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/auth.reducer.ts